/**
 *
 */
class       FriendState    {

    /**
     * @param $id
     * @returns {string}
     */
    getValueItem($id){
        let $val="";
        if (typeof $id === 'string' || $id instanceof String){
            $id=parseInt($id, 10);
        }
        switch ($id) {
            case 50:
            {
                $val = "در دست بررسی";
                break;
            }
            case 55:
            {
                $val = "پذیرش شده";
                break;
            }
            case 60:
            {
                $val = "عدم پذیرش";
                break;
            }
            case 65:
            {
                $val = "غیرفعال";
                break;
            }
            case 100:
            {
                $val = "بایگانی";
                break;
            }
            default:
                break;
        }
        return $val;
    }


    /**
     * @param $data
     * @param $idElement
     * @param $locale
     */
    change($data,  $idElement,  $locale)
    {
        var $key;
        var $item;
        if($data) {
            switch ($locale) {
                default:
                case "fa_IR":
                {
                    for ($key in $data) {
                        $item=$data[$key];
                        $data[$key][$idElement] = this.getValueItem($item[$idElement]);
                    }
                    break;
                }
            }
        }
    }


    /**
     * @param $locale
     * @returns {[]}
     */
    getItems($locale) {
        let $items=[];
        switch ($locale) {
            default:
            case "fa_IR":
                {
                    $items.push({id:50,title:"در دست بررسی"});
                    $items.push({id:55,title:"پذیرش شده"});
                    $items.push({id:60,title:"عدم پذیرش"});
                    $items.push({id:65,title:"غیرفعال"});
                    $items.push({id:100,title:"بایگانی"});
                }
        }
        return $items;
    }

}

export default FriendState ;
